import { Colors } from '../../../../shared/theme';

export default {
  formWrapper: {
    backgroundColor: Colors.white,
    padding: '40px',
  }
};
